/**
 * Controls the animation state of logo carousels.
 * 
 * @param {NodeList|Array} logoWrappers - Collection of DOM elements containing logo carousels
 * @returns {void}
 */
const logos = logoWrappers => {
  if (!logoWrappers) return;

  logoWrappers.forEach(wrapper => {
    const pauseButton = wrapper.querySelector('.logos__pause-button');
    const logoWrapper = wrapper.querySelector('.logos__wrapper');

    if (!pauseButton || !logoWrapper) return;

    pauseButton.addEventListener('click', () => {
      const isPaused = pauseButton.getAttribute('aria-pressed') === 'true';
      
      logoWrapper.style.animationPlayState = isPaused ? 'running' : 'paused';
      pauseButton.setAttribute('aria-pressed', !isPaused);
      pauseButton.setAttribute(
        'aria-label', 
        `${isPaused ? 'Pause' : 'Play'} logo animation`
      );
    });
  });
};

export default logos;
